import { useMemo } from "react";
import { TASK_STATUSES, taskStatusMeta } from "@/lib/mockData";
import TaskCard from "./TaskCard";
import { cn } from "@/lib/utils";

export default function TaskKanban({ tasks, onOpen }) {
  const columns = useMemo(
    () =>
      TASK_STATUSES.map((status) => ({
        status,
        meta: taskStatusMeta[status],
        items: tasks.filter((t) => t.status === status),
      })),
    [tasks],
  );

  return (
    <div
      data-testid="task-kanban"
      className="-mx-5 overflow-x-auto px-5 pb-2 sm:-mx-0 sm:overflow-x-visible sm:px-0"
    >
      <div className="flex min-w-max gap-4 sm:grid sm:min-w-0 sm:grid-cols-2 sm:gap-4 xl:grid-cols-4">
        {columns.map((col) => (
        <div
          key={col.status}
          data-testid={`kanban-col-${col.status}`}
          className="flex w-[280px] flex-shrink-0 flex-col gap-3 rounded-[24px] bg-white/60 p-4 sm:w-auto"
          style={{ border: "1px solid rgba(0,0,0,0.04)" }}
        >
          <div className="flex items-center justify-between px-1">
            <div className="flex items-center gap-2">
              <span
                className="inline-block h-1.5 w-1.5 rounded-full"
                style={{ backgroundColor: col.meta.dot }}
              />
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-700">
                {col.meta.label}
              </span>
            </div>
            <span
              data-testid={`kanban-col-${col.status}-count`}
              className={cn(
                "rounded-full px-2 py-0.5 text-[10px] font-bold",
                col.meta.chip,
              )}
            >
              {col.items.length}
            </span>
          </div>

          <div className="flex flex-col gap-3">
            {col.items.length === 0 ? (
              <div className="rounded-2xl border border-dashed border-black/[0.06] bg-white/40 p-6 text-center text-[11px] text-zinc-400">
                Nothing here yet.
              </div>
            ) : (
              col.items.map((t) => (
                <TaskCard key={t.id} task={t} onOpen={onOpen} />
              ))
            )}
          </div>
        </div>
      ))}
      </div>
    </div>
  );
}
